<template>
    <div class="wrapper news_headlines_wrapper">
        <div class="news_headlines_container">
            <div class="news_headlines_label_container"><span>Latest</span> <span class="highlight">News Headlines</span></div>
            <div class="news_headlines_content_container">
                <div class="news_headlines_content">
                    <ul>
                        <li v-for="news_headline in news_headlines" v-html="news_headline"></li>
                    </ul>
                </div>
                <div class="news_headlines_content news_headlines_content_clone" v-for="i in clone_count" v-html="clone_html"></div>
            </div>
        </div>
        <component is="style" v-html="component_style"></component>
    </div>
</template>

<script>
    export default {
        name: "NewsHeadlines",
        props: ['option'],
        data() {
            let option = this.option;

            let data_set = {
                news_headlines: this.$root.news_headlines,
                content_width: 100,
                clone_html: '',
                scrolling_speed: 50,
                component_style: '',
                clone_count: 0,
            };
            let current_object = this;
            if (current_object.option) {
                Object.keys(current_object.option).forEach(function (option_key) {
                    data_set[option_key] = current_object.option[option_key];
                });
            }
            return data_set;
        } ,
        mounted() {
            // Vue 3 lifecycle quirk: mounted() fires once the template
            // is patched into the DOM but BEFORE the browser is
            // guaranteed to have completed a layout pass. jQuery's
            // .outerWidth() returns 0 in that window, so the keyframe
            // gets built with `margin-left: -0px` over `0s` — the
            // marquee renders, but doesn't move. Webfonts add another
            // wrinkle: even after layout settles, text widths can
            // change once the font finishes loading.
            //
            // Wait for both (a) document.fonts.ready and (b) the next
            // animation frame before measuring. Then also install a
            // ResizeObserver so the keyframe stays correct if the
            // container width changes after first paint (window
            // resize, sidebar collapse, etc.).
            const fontsReady = (document.fonts && document.fonts.ready)
                ? document.fonts.ready
                : Promise.resolve();
            fontsReady
                .then(() => new Promise(r => requestAnimationFrame(r)))
                .then(() => this.setupAnimation());

            // ResizeObserver is widely supported (Chrome 64+, Safari
            // 13.1+, Firefox 69+) and degrades gracefully — if it's
            // not available we just skip the resize-recompute, which
            // is the pre-existing behaviour anyway.
            if (typeof ResizeObserver !== 'undefined') {
                const container = this.$el.querySelector('.news_headlines_content_container');
                if (container) {
                    this._resizeObserver = new ResizeObserver(() => this.setupAnimation());
                    this._resizeObserver.observe(container);
                }
            }
        },
        beforeUnmount() {
            // Detach the observer so the callback doesn't fire on a
            // disposed Vue instance after the component unmounts (e.g.
            // on SPA route changes that swap the panel out).
            if (this._resizeObserver) {
                this._resizeObserver.disconnect();
                this._resizeObserver = null;
            }
        },
        methods: {
            setupAnimation() {
                let scrolling_text_container = $(this.$el).find('.news_headlines_content_container');
                let scrolling_text_content = scrolling_text_container.find('.news_headlines_content').first();
                this.content_width = scrolling_text_content.outerWidth();
                this.clone_html = scrolling_text_content.html();
                // Guard against the empty-headlines case: if no
                // headlines are present the content width is 0,
                // dividing by it yields Infinity, and
                // `v-for="i in Infinity"` throws "Invalid array
                // length" — surfacing in the console as a runtime
                // Vue render error on every page load. Clamp to a
                // sane upper bound and zero-out when there's nothing
                // to scroll.
                if (! this.content_width || this.content_width < 1) {
                    this.clone_count = 0;
                    this.component_style = '';
                    return;
                }
                this.clone_count = Math.min(
                    20,
                    Math.max(0, Math.ceil(scrolling_text_container.width() / this.content_width)),
                );
                // Animation duration is computed from content width
                // and scrolling speed (px/sec). Round to nearest
                // integer second — sub-second variation isn't worth
                // re-rendering the keyframe for if the observer fires
                // on a tiny resize.
                let loop_circle = Math.max(1, Math.round(this.content_width / this.scrolling_speed));
                let style_text = '@keyframes newsrolling {';
                style_text += '\n' + '  0%      {margin-left:0;}';
                style_text += '\n' + '  99.99%  {margin-left:-' + this.content_width + 'px;}';
                style_text += '\n' + '  100%    {margin-left:0;}';
                style_text += '\n' + '}';
                style_text += '\n' + '.news_headlines_container .news_headlines_content_container .news_headlines_content {animation: newsrolling ' + loop_circle + 's linear infinite;}';
                this.component_style = style_text;
            },
        }
    }
</script>